module.exports = __webpack_public_path__ + "static/media/Bristol-Corners-Bylaws.f0b34b44.pdf";